import React from 'react';
import { useAuth } from '../../../context/auth-context.jsx';
import { adminApi } from '../../../lib/admin-api/index.js';

export const ComplianceModeContext = React.createContext({
  complianceMode: 'gdpr',
  isFinancialRegulation: false,
  isLoading: true,
});

export function ComplianceModeProvider({ children }) {
  const { token } = useAuth();
  const [state, setState] = React.useState({
    complianceMode: 'gdpr',
    isFinancialRegulation: false,
    isLoading: true,
  });

  React.useEffect(() => {
    let isCancelled = false;

    if (!token) {
      setState({
        complianceMode: 'gdpr',
        isFinancialRegulation: false,
        isLoading: false,
      });
      return undefined;
    }

    const load = async () => {
      setState((prev) => ({ ...prev, isLoading: true }));

      try {
        const response = await adminApi.getSystemGeneralSettings(token);
        const complianceMode = String(response?.complianceMode || 'gdpr').trim() || 'gdpr';

        if (!isCancelled) {
          setState({
            complianceMode,
            isFinancialRegulation: complianceMode === 'financial_regulation',
            isLoading: false,
          });
        }
      } catch {
        if (!isCancelled) {
          setState({
            complianceMode: 'gdpr',
            isFinancialRegulation: false,
            isLoading: false,
          });
        }
      }
    };

    load();

    return () => {
      isCancelled = true;
    };
  }, [token]);

  return (
    <ComplianceModeContext.Provider value={state}>
      {children}
    </ComplianceModeContext.Provider>
  );
}

export function useComplianceMode() {
  return React.useContext(ComplianceModeContext);
}
